export default __webpack_public_path__ + "haalfashion-black.png";